import EngineCleanupBase from '../../../services/engines/EngineCleanupBase';
import componentNotifier from '../../../services/wss/ComponentNotifier';
import { EngineNames } from '../../../services/wss/events/EngineNames';
import umlPkgLibCache from './UmlPkgLibCache';
import umlPkgLibFetcher from './UmlPkgLibFetcher';

const _name = EngineNames.UmlPkgLibEngine;

/**
 * UmlPkgLibEngine — holds cached UmlPkgLib notes (package templates).
 */
class UmlPkgLibEngine extends EngineCleanupBase {
    bootup = () => {
        this.initialize(_name);
    };

    fetchAll = async () => {
        await umlPkgLibFetcher.fetch();
        this._notify();
    };

    /**
     * All cached UmlPkgLib notes — used by UmlPkgLibViewerDlg for the list.
     * @returns {object[]}
     */
    getAll = () => umlPkgLibCache.getAll();

    /**
     * One UmlPkgLib note by rk, or null.
     * @param {string} rk
     * @returns {object|null}
     */
    getByRk = (rk) => umlPkgLibCache.get(rk);

    /**
     * Adds a just-saved/created note directly to the cache — called from
     * UmlPkgLibSaveAction after a successful save, mirrors UmlNotesEngine.upsert.
     * @param {object} note
     */
    upsert = (note) => {
        try {
            if (!note?.rk) return;
            umlPkgLibCache.addOrUpdate([note]);
            this._notify();
        } catch (error) {
            this.logError('upsert', error.message);
        }
    };

    /**
     * @param {object[]} entries
     */
    onJournalUpdated = (entries) => {
        try {
            if (!Array.isArray(entries) || !entries.length) return false;

            const items = entries.filter((x) => x.type === 'UmlPkgLib');
            if (items.length === 0) return;

            umlPkgLibCache.addOrUpdate(items);
            this._notify();
            return true;
        } catch (error) {
            this.logError('onJournalUpdated', error.message);
            return false;
        }
    };

    /**
     * @param {string} rk
     */
    onJournalDeleted = (rk) => {
        try {
            if (!rk) {
                this.logError('onJournalDeleted', `Invalid row key - ${rk}`);
                return false;
            }

            const deleted = umlPkgLibCache.delete(rk);
            if (!deleted) return;

            this._notify();
            return deleted;
        } catch (error) {
            this.logError('onJournalDeleted', error.message);
            return false;
        }
    };

    // ─── private ──────────────────────────────────────────

    _notify = () => {
        componentNotifier.notify(_name, 'dataChanged', {
            items: umlPkgLibCache.getAll(),
        });
    };

    clear = () => {
        umlPkgLibCache.clear();
        super.clear();
    };
}

const umlPkgLibEngine = new UmlPkgLibEngine();
export default umlPkgLibEngine;
